var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{attrs:{"color":_vm.colors[_vm.status].background,"text-color":_vm.colors[_vm.status].text}},[_vm._v(" "+_vm._s(_vm.capitalizeString(_vm.status))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }